<label class="plan basic-plan" for="basic">
  <div class="plan-content" [ngClass]="{'grey': isGrey}">
    <div class="bg-plan" [ngClass]="{'white': isGrey}">
      <img
        loading="lazy"
        [src]="imageSrc"
        alt=""
      />
    </div>
    <div class="plan-details">
      <h1>{{ title | translate }}</h1>
      <input
        type="radio"
        [checked]="isSelected"
        class="input-radio"
        [name]="roleType"
        (change)="onRoleClick()"
      />
    </div>
  </div>
</label> 